<template>
  <div class="form-group row">
    <div class="col-sm-2 col-form-label pb-1 text-left text-sm-right">
      <label class="mb-0 text-muted" v-bind:class="{'text-danger': errors && errors.length > 0}" v-html="label"></label>
    </div>
    <div class="col-sm-10">
      <slot></slot>
      <small class="help-block text-danger" v-for="error in errors">
        {{error}}<br>
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormGroupRow',
  data: function(){
    return {}
  },
  computed: {
    errors: function(){
      return this.item && this.item.errors && this.item.errors[this.attribute];
    }
  },
  props: {
    label: {
      type: String,
      required: true
    },
    item: {},
    attribute: {
      type: String,
      required: true
    }
  }
}
</script>
